import { render, staticRenderFns } from "./RdvCession.vue?vue&type=template&id=55d28522&"
import script from "./RdvCession.vue?vue&type=script&lang=js&"
export * from "./RdvCession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RdvCession.vue"
export default component.exports